<template>
  <div class="checkIn-info">
    <div class="detail_info">
      <div>
        <img :src="join_user.avatar">
        <span class="nickname">{{join_user.nickname}}</span>
      </div>
      <div>
        <span class="info_title">所用时长</span>
        <span>{{join_user.total_seconds || join_user.total_seconds==0?$pub.formatSeconds(join_user.total_seconds):'--'	}}</span>
      </div>
      <div>
        <span class="info_title">正确率</span>
        <span>{{join_user.right_percent?join_user.right_percent+'%':'--'}}</span>
      </div>
      <div>
        <span class="info_title">得分</span>
        <span>{{join_user.total_score||join_user.total_score==0?join_user.total_score+'″':'--'}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import avatar from '@/assets/images/avatar.png';
export default {
  name: "CheckInItem",
  props: {
    report: {
      type: Object
    },
    join_user: {
      type: Object,
      default: () => {
        return {
          avatar: avatar,
          nickname: '--'
        };
      }
    }
  },
  data () {
    return {
    };
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.checkIn-info {
  font-family: PingFang SC;
  color: #333;
  font-size: 24px;
  .detail_info {
    height: 222px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(56, 56, 56, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-around;
    div {
      text-align: center;
      span {
        display: block;
        color: #222222;
        font-size: 32px;
        margin-top: 35px;
        font-weight: 600;
      }
      img {
        width: 120px;
        height: 120px;
        border-radius: 50%;
      }
      .info_title {
        color: #999999;
        font-size: 24px;
        margin-top: 0px;
      }
      .nickname {
        margin-top: 14px;
        font-size: 30px;
        color: #222222;
      }
    }
  }
}
</style>
